import { search } from '@debbie/common/dist/util/index.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { Filter as FilterIcon } from '../Icons/index.js';
import { availableFilters, filters } from './filter-options.js';
import { FilterDisplay } from './filter/FilterDisplay.js';
import { FilterConfiguration, FilterOptionSelector, FilterTypeConfiguration, } from './FilterConfiguration.js';
import { toKey } from './util.js';
export const FilterMenuV2 = (props) => {
    const lang = useSelector((s) => s.lang);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [optionSelected, setOptionSelected] = useState(null);
    const [openFilter, setOpenFilter] = useState(null);
    const [openTypeFilter, setOpenTypeFilter] = useState(null);
    const [index, setIndex] = useState(0);
    const dropSearchRef = useRef(null);
    const configSearchRef = useRef(null);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);
    const configRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (configRef.current &&
                !configRef.current.contains(event.target)) {
                setOpenFilter(null);
            }
        };
        if (openFilter != null) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openFilter]);
    const typeConfigRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (typeConfigRef.current &&
                !typeConfigRef.current.contains(event.target)) {
                setOpenTypeFilter(null);
            }
        };
        if (openTypeFilter != null) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openTypeFilter]);
    const updateOrAddFilter = (filter) => {
        if ('remove' in filter) {
            props.setFilters((prev) => {
                const filterIndex = prev.findIndex((f) => f.id === filter.id);
                return [...prev.slice(0, filterIndex), ...prev.slice(filterIndex + 1)];
            });
            return;
        }
        props.setFilters((prev) => {
            const filterIndex = prev.findIndex((f) => toKey(f) === toKey(filter));
            if ('values' in filter && filter.values.length === 0) {
                return [...prev.slice(0, filterIndex), ...prev.slice(filterIndex + 1)];
            }
            if (filterIndex != -1) {
                return [
                    ...prev.slice(0, filterIndex),
                    filter,
                    ...prev.slice(filterIndex + 1),
                ];
            }
            return [...prev, filter];
        });
    };
    const removeFilter = (index) => {
        props.setFilters((prev) => {
            return [...prev.slice(0, index), ...prev.slice(index + 1)];
        });
    };
    const selectOption = (option) => {
        setOptionSelected(option);
        setSearchText('');
    };
    return (React.createElement(Wrapper, null,
        props.filters.map((f, i) => {
            const option = filters[f.filterKey];
            return (React.createElement(FilterWrapper, { key: f.id },
                React.createElement(FilterDisplay, { onRemove: () => removeFilter(i), label: option.label(lang) }, React.createElement(filters[f.filterKey].display, {
                    filter: f,
                    toggleFilterConfig: () => {
                        if (openFilter === f.id) {
                            setOpenFilter(null);
                        }
                        else {
                            setOpenFilter(f.id);
                            setSearchText('');
                        }
                    },
                    toggleFilterTypeConfig: () => {
                        if (openTypeFilter === f.id) {
                            setOpenTypeFilter(null);
                        }
                        else {
                            setOpenTypeFilter(f.id);
                        }
                    },
                })),
                openFilter === f.id ? (React.createElement(Dropdown, { ref: configRef },
                    filters[f.filterKey] &&
                        filters[f.filterKey].omitSearch ? null : (React.createElement(SearchInput, { type: "text", autoFocus: true, placeholder: `${lang.misc.search}...`, value: searchText, onChange: (e) => {
                            setSearchText(e.target.value);
                        }, ref: configSearchRef })),
                    React.createElement(DropdownItems, null,
                        React.createElement(FilterConfiguration, { filterOption: filters[f.filterKey], filter: f, searchText: searchText, onFilterUpdate: (filter) => {
                                updateOrAddFilter(filter);
                                configSearchRef.current?.focus();
                            }, onCloseMenu: () => {
                                setOpenFilter(null);
                            } })))) : null,
                openTypeFilter === f.id ? (React.createElement(Dropdown, { ref: typeConfigRef },
                    React.createElement(DropdownItems, null,
                        React.createElement(FilterTypeConfiguration, { filterOption: filters[f.filterKey], filter: f, onFilterUpdate: (filter) => {
                                updateOrAddFilter(filter);
                            }, onCloseMenu: () => {
                                setOpenTypeFilter(null);
                            } })))) : null));
        }),
        React.createElement(FilterButtonWrapper, null,
            React.createElement(FilterButton, { style: { display: 'flex' }, onClick: () => {
                    setIsDropdownOpen(!isDropdownOpen);
                    setOptionSelected(null);
                    setOpenFilter(null);
                    setSearchText('');
                } },
                React.createElement(FilterIcon, null),
                lang.views.filter),
            isDropdownOpen && (React.createElement(Dropdown, { ref: dropdownRef },
                optionSelected != null && optionSelected.omitSearch ? null : (React.createElement(SearchInput, { type: "text", autoFocus: true, placeholder: `${lang.misc.search}...`, value: searchText, onChange: (e) => {
                        setSearchText(e.target.value);
                    }, ref: dropSearchRef })),
                React.createElement(DropdownItems, null, optionSelected ? (React.createElement(FilterConfiguration, { filterOption: optionSelected, searchText: searchText, onFilterUpdate: (filter) => {
                        setOpenFilter(filter.id);
                        setOptionSelected(null);
                        setIsDropdownOpen(false);
                        updateOrAddFilter(filter);
                    }, onCloseMenu: () => {
                        setOptionSelected(null);
                        setOpenFilter(null);
                        setIsDropdownOpen(false);
                    } })) : (React.createElement(FilterOptionSelector, { filterOptions: search((availableFilters[props.base] ?? []).map((filterName) => filters[filterName]), (opt) => opt.label(lang), searchText, {}), onSelectToplevelOption: (option) => {
                        selectOption(option);
                        dropSearchRef.current?.focus();
                    }, onSelectFilterOption: (key) => { } })))))),
        React.createElement(FilterButton, { style: {
                marginLeft: 'auto',
                padding: 4,
                cursor: 'pointer',
            }, onClick: () => props.setFilters([]) }, lang.views.clear)));
};
const DropdownItems = styled.div `
  display: flex;
  padding: 4px;
  flex-direction: column;
  max-height: calc(100vh - 350px);
  overflow-y: auto;
  scrollbar-width: none;
`;
const Dropdown = styled.div `
  position: absolute;
  background-color: #fefefe;
  border-radius: 4px;
  border: 1px solid lightgray;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;
const FilterWrapper = styled.div `
  display: inline-block;
  user-select: none;
  cursor: pointer;
  position: relative;
`;
const FilterButtonWrapper = styled.div `
  display: inline-block;
  user-select: none;
  position: relative;
`;
const FilterButton = styled.button `
  transition: background-color 50ms ease-in-out;
  display: flex;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  background: transparent;
  font-size: 1em;
  color: ${THEME.COLOR_PRIMARY};

  &:hover {
    background-color: color-mix(in hsl, ${THEME.COLOR_GREY}, transparent 80%);
  }
`;
const Wrapper = styled.div `
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 4px;
  border: 1px solid lightgray;
  display: flex;
  gap: 8px;
  padding: 4px;
  color: ${THEME.COLOR_PRIMARY};
`;
const SearchInput = styled.input `
  padding: 8px 16px;
  font-size: 1em;
  outline: none;
  border: none;
  background: none;
  border-bottom: 1px solid lightgray;
  width: 100%;
`;
//# sourceMappingURL=FilterMenuV2.js.map